import type { ReactNode } from 'react';
import styled from 'styled-components';

import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';
import type { Color } from '@sorare/core/src/style/types';

const Root = styled(Bezel)`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: var(--triple-unit) var(--double-unit);
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
`;

const TextureBackgroundWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  & > * {
    width: 100%;
    height: 100%;
  }
  &:after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(var(--c-rgb-black), 0.1) 0%,
      rgba(var(--c-rgb-black), 0.85) 100%
    );
  }
`;

type Props = {
  color: Color;
  children: ReactNode;
};

export const FeaturedMissionCard = ({ color, children }: Props) => {
  return (
    <Root borderColor={color}>
      <TextureBackgroundWrapper>
        <TextureBackground
          background="missions"
          mode="light"
          color={color}
          withDots
        />
      </TextureBackgroundWrapper>
      {children}
    </Root>
  );
};
